export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILED = "FETCH_USER_FAILED";
export const FETCH_USER_START = "FETCH_USER_START";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_START = "LOGIN_START";

export const LOGOUT = "LOGOUT";

export const GET_GALLERY_SUCCESS = "GET_GALLERY_SUCCESS";
export const GET_JOB_SUCCESS = "GET_JOB_SUCCESS";
export const VERIFY = "VERIFY";
export const NOT_VERIFIED = 'NOT_VERIFIED';
export const NOT_VERIFIED_MESSAGE = 'NOT_VERIFIED_MESSAGE';
export const VERIFICATION_CREDENTIALS = "VERIFICATION_CREDENTIALS"


